import { useCallback, useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import HOC from '../../components/HOC/HOC';
import {
  DeleteSuccessfullyModal,
  SuccessfullyModal,
  ViewStaffProfile,
} from '../../components/Modals/Modals';
import Pagination from '../../components/Pagination/Pagination';
import styles from '../../css/style.module.css';
import { deleteApi, getApi } from '../../Repository/Api';
import endPoints from '../../Repository/apiConfig';

import img from '../../assest/img7.png';
import img2 from '../../assest/loading1.gif';

import { FaRegEdit } from 'react-icons/fa';
import { FaPlus } from 'react-icons/fa6';
import { IoSearchSharp } from 'react-icons/io5';
import { RiDeleteBin6Line } from 'react-icons/ri';

const columns = [
  'S.no',
  'ID',
  'Name',
  'Email',
  'Number',
  'Job Role',
  'Unique-ID',
  // 'Password',
  'Wallet',
  'Status',
  'Ledger',
  'Action',
];

const Registered = () => {
  const navigate = useNavigate();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showUserprfileModal, setShowUserProfileModal] = useState(false);
  const [staffdata, setStaffData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [search, setSearch] = useState('');
  const [pagination, setPagination] = useState({
    limit: 10,
    totalPages: 1,
    page: 1,
    hasPrevPage: false,
    hasNextPage: false,
  });

  const fetchData = useCallback(async () => {
    await getApi(endPoints.getallRegisteredStaff(pagination.page, pagination.limit, search), {
      setResponse: setStaffData,
      setLoading,
      errorMsg: 'Failed to fetch user!',
    });
  }, [pagination.page, pagination.limit, search]);

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      totalPages: staffdata?.data?.totalPages,
      hasPrevPage: staffdata?.data?.hasPrevPage,
      hasNextPage: staffdata?.data?.hasNextPage,
    }));
  }, [staffdata]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleDelete = async () => {
    if (!selectedUser) return;

    await deleteApi(endPoints.deleteUser(selectedUser), {
      setLoading,
      // successMsg: 'Category deleted successfully!',
      errorMsg: 'Failed to delete staff!',
    });

    fetchData();
    setShowDeleteModal(false);
    setShowSuccessModal(true);
    setTimeout(() => setShowSuccessModal(false), 2000);
  };

  const openDeleteModal = (categoryId) => {
    setSelectedUser(categoryId);
    setShowDeleteModal(true);  
  };

  const routeMapping = {
    Registered: '/staff-management/registered',
    'Active Employee': '/staff-management/active-employee',
    'Track Employee': '/staff-management/track-employee',
  };

  const openModal = (user) => {
    setSelectedUser(user);
    setShowUserProfileModal(true);
  };

  const handleSearchChange = (e) => {
    setSearch(e.target.value);
    setPagination({ ...pagination, page: 1 });
  };

  return (
    <>
      <DeleteSuccessfullyModal
        show={showDeleteModal}
        handleClose={() => setShowDeleteModal(false)}
        handleConfirm={handleDelete}
        text="delete Staff"
      />
      <SuccessfullyModal
        show={showSuccessModal}
        handleClose={() => setShowSuccessModal(false)}
        text="Successfully Deleted"
      />
      <ViewStaffProfile
        show={showUserprfileModal}
        data={selectedUser}
        onHide={() => setShowUserProfileModal(false)}
      />
      <div className={styles.jobmanagementCotainer}>
        <div className={styles.jobtoppart}>
          <div className={styles.pagetitle}>
            <h6>Staff Management</h6>
            <div className={styles.searchbarnav}>
              <IoSearchSharp color="#8A8A8A" size={20} />
              <input
                type="search"
                placeholder="Search"
                value={search}
                onChange={handleSearchChange}
              />
            </div>
          </div>
          <div className={styles.rightbuttons}>
            <div
              className={styles.rightbuttons2}
              onClick={() => navigate('/staff-management/registered/addstaff')}
            >
              <FaPlus color="#FFFFFF" />
              <p>Add New Staff</p>
            </div>
          </div>
        </div>
        <div className={styles.jobselectcontainer}>
          <div className={styles.jobStatusContainer}>
            {['Registered', 'Active Employee', 'Track Employee'].map((item, index) => (
              <Link key={index} to={routeMapping[item]} className={styles.link}>
                <p
                  className={
                    item === 'Registered' ? styles.jobOptionTrueactive : styles.jobOptionnotactive
                  }
                >
                  {item}
                </p>
              </Link>
            ))}
          </div>
        </div>
        <div className={styles.jobchildcontainer}>
          <div className={styles.tablecontainer}>
            <table className={styles.table1}>
              <thead>
                <tr>
                  {columns.map((label, index) => (
                    <th key={index} className={styles.tableHeader}>
                      {label}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {loading ? (
                  <tr>
                    <td colSpan="13" style={{ textAlign: 'center', padding: '1rem' }}>
                      <img src={img2} alt="" width={100} height={100} />
                    </td>
                  </tr>
                ) : staffdata?.data?.docs?.length === 0 ? (
                  <tr>
                    <td colSpan="13" style={{ textAlign: 'center', padding: '1rem' }}>
                      No data available.
                    </td>
                  </tr>
                ) : (
                  staffdata?.data?.docs?.map((register, rowIndex) => (
                    <tr key={rowIndex} className={styles.tableRow}>
                      <td className={styles.tableCell}>{rowIndex + 1}</td>
                      <td className={styles.tableCell}>{register.Id}</td>
                      <td className={styles.tableCell}>
                        <div
                          className={styles.tableprofilecontainer}
                          onClick={() => openModal(register)}
                        >
                          <div className={styles.tablecellprofile}>
                            <div className={styles.tablecellprofileimg}>
                              <img src={register?.image ? register?.image : img} alt="" />
                            </div>
                          </div>
                          {register?.firstName} {register?.lastName}
                        </div>
                      </td>
                      <td className={styles.tableCell}>{register?.email}</td>
                      <td className={styles.tableCell}>{register?.phone}</td>
                      <td className={styles.tableCell}>
                        <ul>
                          {register?.subcategoryId?.length === 0 ? (
                            <option value="">No Role</option>
                          ) : (
                            register?.subcategoryId?.map((cat, idx) => (
                              <li key={idx}>{cat?.name}</li>
                            ))
                          )}
                        </ul>
                      </td>
                      <td className={styles.tableCell}>{register?.uniqueId}</td>
                      {/* <td className={styles.tableCell}></td> */}
                      <td className={styles.tableCell}>{register?.wallet ?? 0}</td>
                      <td className={styles.tableCell}>
                        <div className={styles.tablecreatebutton}>
                          <p
                            style={{
                              color:
                                register?.status === 'Pending'
                                  ? '#FFA800'
                                  : register?.status === 'Active'
                                  ? '#00AD1D'
                                  : 'black',
                              fontWeight: '600',
                            }}
                          >
                            {register.status}
                          </p>
                          <Link
                            to={`/staff-management/registered/createuser-id&Password/${register._id}`}
                          >
                            <button>Create</button>
                          </Link>
                        </div>
                      </td>
                      <td className={styles.tableCell}>
                        <Link
                          to={`/staff-management/registered/staff-ledger/${register._id}`}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{ color: '#f05423', fontWeight: 600, fontSize: 13 }}
                        >
                          View Ledger
                        </Link>
                      </td>
                      <td>
                        <div className={styles.tableaction}>
                          <Link to={`/staff-management/registered/editstaff/${register?._id}`}>
                            <FaRegEdit size={20} style={{ cursor: 'pointer', color: '#e9b44a' }} />
                          </Link>
                          <RiDeleteBin6Line
                            size={20}
                            onClick={() => openDeleteModal(register._id)}
                            style={{ cursor: 'pointer', color: '#d9534f' }}
                          />
                        </div>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </table>
          </div>
          <Pagination
            limit={pagination.limit}
            totalPages={pagination.totalPages}
            page={pagination.page}
            hasPrevPage={pagination.hasPrevPage}
            hasNextPage={pagination.hasNextPage}
            onPageChange={(newPage) => setPagination({ ...pagination, page: newPage })}
          />
        </div>
      </div>
    </>
  );
};

export default HOC(Registered);
